



















































import { Component, Prop, Vue } from "vue-property-decorator";
import { formatDistanceToNowStrict } from "date-fns";
import { IDiscussion } from "../../types/discussions";
import RouteName from "../../router/name";

@Component
export default class DiscussionListItem extends Vue {
  @Prop({ required: true, type: Object }) discussion!: IDiscussion;

  RouteName = RouteName;

  formatDistanceToNowStrict = formatDistanceToNowStrict;

  get htmlTextEllipsis(): string {
    const element = document.createElement("div");
    if (this.discussion.lastComment && this.discussion.lastComment.text) {
      element.innerHTML = this.discussion.lastComment.text
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<p>/gi, " ");
    }
    return element.innerText;
  }

  get actualDate(): string | Date | undefined {
    if (
      this.discussion.updatedAt === this.discussion.insertedAt &&
      this.discussion.lastComment
    ) {
      return this.discussion.lastComment.publishedAt;
    }
    return this.discussion.updatedAt;
  }
}
